var _path, _path2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAufkleberinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.67 0h39v39h-39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.455 19.004c.53.046.863.194.507.712-.397.578-1.467 1.038-1.686.136-.049-.202-.152-.864.304-1.125.515-.295.549.248.875.277z",
    fill: "url(#aufkleber_inline_svg__aufkleber_inline_svg___Linear1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.169 21.386l-.267.15c-.08.044-.162.087-.245.127-2.082 1.023-4.962 1.049-6.901 3.28-1.359 1.561-1.478 4.057-3.126 6.332l-.148.139c-.171.008-.342.013-.514.013-6.409 0-11.605-5.196-11.605-11.605 0-6.408 5.196-11.604 11.605-11.604 6.408 0 11.604 5.196 11.604 11.604 0 .422-.024.839-.068 1.25l-.335.314z",
    fill: "url(#aufkleber_inline_svg__aufkleber_inline_svg___Linear2)",
    stroke: "#fff",
    strokeWidth: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.448 21.375a5.402 5.402 0 01-.558.301c-2.13 1.046-5.076 1.073-7.06 3.356-1.419 1.63-1.516 4.257-3.306 6.624-.023.031 3.79-.395 7.195-3.81 3.468-3.482 4.036-6.743 4.037-6.75-.138.093-.163.192-.308.279z",
    fill: "#fff",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aufkleber_inline_svg__aufkleber_inline_svg___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-92 19.927 .42) scale(1.72096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005791",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ddf",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aufkleber_inline_svg__aufkleber_inline_svg___Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 3082.015 5169.975) scale(4060.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ee0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005792",
    stopOpacity: 1
  })))));
}

export default SvgAufkleberinline;